//Don't modify this file directly!

/* eslint-disable */
export const gitInfo = {
	branchName: 'HEAD',
	sha: '0aae5664b6e53dba04aa68546b0aa3ca9a8d21e3',
	shaShort: '0aae5664b',
};
/* eslint-enable */